// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xcZrmZPPK32a4dkveKngE"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Home/styles.css
// module id = 1052
// module chunks = 21